// CHECKER ENDPOINTS
export const CHECKER_ENDPOINTS = {
  DASHBOARD_CARDS: "/reports/checker-approver-farmer-counts",
  FARMER_LIST: "/farmer/table",
  FARMER_DETAILS: "/farmer/view",
  VERIFY_FARMER: "/farmer/check",
  REVERT_FARMER: "/farmer/revert",
  VIEW_PROFILE: "/checker/view",
  UPDATE_PROFILE: "/checker",
};

// APPROVER ENDPOINTS
export const APPROVER_ENDPOINTS = {
  DASHBOARD_CARDS: "/reports/checker-approver-farmer-counts",
  FARMER_LIST: "/farmer/table",
  FARMER_DETAILS: "/farmer/view",
  VERIFY_FARMER: "/farmer/approve",
  REVERT_FARMER: "/farmer/revert",
  VIEW_PROFILE: "/approver/view",
  UPDATE_PROFILE: "/approver",
};


// ADMIN USER MANAGEMENT ENDPOINTS
export const ADMIN_ENDPOINTS = {
  CREATE_USER: "/users",
  VIEW_TABLE: "/users/table",
  VIEW_USER: "/users/view",
  UPDATE_USER: "/users",

  CREATE_GROUP: "/user-group",
  VIEW_GROUP: "/user-group/view",
  UPDATE_GROUP: "/user-group",
  VIEW_GROUP_TABLE: "/user-group/table",
  GET_GROUP_RIGHTS: "/user-group/get-rights",
  UPDATE_GROUP_RIGHTS: "/user-group/update-rights",
  GROUP_USERS: "/user-group/users",
  ASSIGN_GROUP_USERS: "/user-group/assign-users",
}
// ADMIN REPORTS ENDPOINTS
export const ADMIN_REPORTS_ENDPOINTS = {
  DASHBOARD_REPORTS: "/reports/admin-dashboards",
  MAP_DASHBOARD_CARDS: "/reports/districtwise-dcs-farmer-counts",
  RETAILER_MAP_COUNTS: "/reports/districtwise-retailer-counts",
  FARMER_TYPEAHEAD: "/farmer/typeahead",
}

//DBT and MILK PROCUREMENT ENDPOINTS
export const DBT_MILK_PROCUREMENT_ENDPOINTS = {
  FARMER_RECORDS: "/dbt/farmer-records",
  REJECTION_REASONS: "/dbt/rejection-reasons",
  DBT_SEND_OTP: "/dbt/send-otp",
  DCS_APPROVE_FARMER: "/dbt/dcs/approve",
  DCS_REJECT_FARMER: "/dbt/dcs/reject",
  //unionApprover milk procurement
  DCS_SUMMARY: "/dbt/dcs-summary",
  DCS_NOT_POURED: "/dbt/dcs-not-poured",
  UNION_APPROVE_FARMER: "/dbt/approver/approve",
  UNION_REJECT_FARMER: "/dbt/approver/reject",
  EXPORT_FARMER_RECORDS: "/dbt/table",
  //deductions
  DEDUCTION_TABLE: "/local-sale/deductions",
  DEDUCTION_DCS_WISE: "/local-sale/deductions/dcs-wise",
  //payout list
  PAYOUT_PENDING_DCS: "/payout/pending",
  PAYOUT_PENDING_FARMERS: "/payout/farmers",
  APPROVE_PAYOUT: "/payout/pay",
  PAID_DCS_LIST: "/payout/paid",
  PAID_FARMERS: "/payout/paid/farmers",
  //FINAL payment sheet
  FINAL_PAYMENT_SHEET: "/payout/paid/farmers/export",
  //PAYMENT CYCLES
  PAYMENT_CYCLE_DROPDOWN: "/payout/cycles",
  PAYMENT_CYCLE_TABLE: "/payment-cycle/table",
  PAYMENT_CYCLE_UPDATE: "/payment-cycle",
  PAYMENT_CYCLE_HISTORY: "/payment-cycle/history",
  //upload payment and payment status
  UPLOAD_PAYMENT: "/payment-details/upload",
  PAYMENT_STATUS: "/payment-details/list",
  //Milk Reconciliation
  MILK_RECONCILIATION_TABLE: "/reconciliation/summary",



}

//VEHICLE TRACKING SYSTEM (VTS) ENDPOINTS
export const VTS_ENDPOINTS = {
  STATUS_COUNTS: "/vts/status-counts",
  VEHICLES: "/vts/vehicles",
  VEHICLE_DETAIL: "/vts/vehicle",
  VEHICLE_HISTORY: "/vts/vehicle/history",
}


// UNION SALE (SALES DASHBOARD) ENDPOINTS
export const UNION_SALE_ENDPOINTS = {
  SCOPES: "/union-sale/scopes",
  OVERVIEW: "/union-sale/overview",
  UNION_WISE: "/union-sale/union-wise",
  TREND: "/union-sale/trend",
  DISTRIBUTORS: "/union-sale/distributors",
  DISTRIBUTOR_MAP: "/union-sale/distributor-map",
}


// DCS DAILY REPORT ENDPOINTS
export const DCS_DAILY_REPORT_ENDPOINTS = {
  META: "/dcs-daily-report/meta",
  FORM: "/dcs-daily-report/form",
  SUBMIT: "/dcs-daily-report/submit",
  MY_SUBMISSIONS: "/dcs-daily-report/my-submissions",
  LIST: "/dcs-daily-report/list",
  VIEW: "/dcs-daily-report/view",
  EXPORT: "/dcs-daily-report/export",
  EDITABLE: "/dcs-daily-report/editable",
}


// SAP PURCHASE ORDERS & MATERIAL MASTER ENDPOINTS
export const SAP_ENDPOINTS = {
  PO_FILTERS: "/sap/purchase-order/filters",
  PO_SUMMARY: "/sap/purchase-order/summary",
  PO_TABLE: "/sap/purchase-order/table",
  PO_VIEW: "/sap/purchase-order/view",
  PO_TREND: "/sap/purchase-order/trend",
  PO_BREAKDOWN: "/sap/purchase-order/breakdown",
  PO_EXPORT: "/sap/purchase-order/export",
  PO_SYNC: "/sap/purchase-order/sync",
  SYNC_LOG: "/sap/sync-log",
  ORG: "/sap/master/org",
  CODES: "/sap/master/codes",
  MATERIALS: "/sap/master/materials",
  MATERIALS_EXPORT: "/sap/master/materials/export",
  MASTER_SYNC: "/sap/master/sync",
}
